module.exports = __webpack_public_path__ + "group_buy/groupbuy_6641-d51b4a3cd5c66c2e8623d3b82eb763cc.png";